export default __webpack_public_path__ + "static/media/ch5.bcf6157c.svg";